module.exports = __webpack_public_path__ + "static/img/main6_8.3df864dc.png";